import React from 'react';
import { StaticPage, TopbarContainer } from '../../../containers';
import { LayoutSingleColumn, LayoutWrapperTopbar, LayoutWrapperMain, LayoutWrapperFooter, Footer } from '../../../components';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import css from './JessicaShoulandPage.module.css';

const JessicaShoulandPage = () => {
  // Author's articles
  const authorArticles = [
    {
      id: 1,
      title: 'How Loyal Is My Partner? - Loyalty Test Quiz',
      description: 'Take this comprehensive quiz to assess your partner\'s loyalty and get personalized recommendations based on your answers.',
      image: '/static/images/blog/what-does-loyalty-in-relationships-look-like-1.jpg',
      link: '/how-loyal-is-my-partner-quiz',
      date: '2024-02-04'
    }
    // More articles will be added here as they are created
  ];

  return (
    <StaticPage
      title="Jessica Shouland - Relationship Expert & Author"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'Person',
        description: 'Jessica Shouland is a relationship expert and author specializing in relationship dynamics, loyalty, and trust.',
        name: 'Jessica Shouland',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <Helmet>
            <meta name="keywords" content="Jessica Shouland, relationship expert, loyalty expert, relationship advice, relationship author" />
            <link rel="canonical" href="https://loyalty-test.com/writers/jessica-shouland" />
            <meta property="og:type" content="profile" />
            <meta property="og:title" content="Jessica Shouland - Relationship Expert & Author" />
            <meta property="og:description" content="Jessica Shouland is a relationship expert and author specializing in relationship dynamics, loyalty, and trust." />
            <meta property="og:image" content="/static/images/blog/what-does-loyalty-in-relationships-look-like-1.jpg" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="Jessica Shouland - Relationship Expert & Author" />
            <meta name="twitter:description" content="Jessica Shouland is a relationship expert and author specializing in relationship dynamics, loyalty, and trust." />
            <meta name="twitter:image" content="/static/images/blog/what-does-loyalty-in-relationships-look-like-1.jpg" />
          </Helmet>

          <div className={css.authorHeader}>
            <div className={css.authorProfile}>
              <div className={css.profileIcon}>
                <span className={css.initials}>JS</span>
              </div>
              <div className={css.authorInfo}>
                <h1 className={css.authorName}>Jessica Shouland</h1>
                <p className={css.authorBio}>
                  Jessica Shouland is a relationship expert and author who specializes in helping people understand and navigate the complexities of modern relationships. With a focus on trust, loyalty, and healthy relationship dynamics, Jessica provides practical advice and insights to help couples build stronger, more meaningful connections.
                </p>
              </div>
            </div>
          </div>

          <div className={css.contentWrapper}>
            <h2 className={css.sectionTitle}>Articles by Jessica</h2>
            <div className={css.articlesGrid}>
              {authorArticles.map(article => (
                <Link 
                  key={article.id} 
                  to={article.link}
                  className={css.articleCard}
                >
                  <img 
                    src={article.image} 
                    alt={article.title} 
                    className={css.articleImage} 
                    loading="lazy"
                    width="300"
                    height="180"
                  />
                  <div className={css.articleContent}>
                    <h3 className={css.articleTitle}>{article.title}</h3>
                    <p className={css.articleDescription}>{article.description}</p>
                    <span className={css.articleDate}>{new Date(article.date).toLocaleDateString()}</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default JessicaShoulandPage; 